// extracted by mini-css-extract-plugin
export var bodyRow = "_es-d";
export var cardColumns = "_es-e";
export var ellipsesOverflow = "_es-2";
export var flatBottomCorners = "_es-3";
export var flatTopCorners = "_es-4";
export var headerActionsDropdown = "_es-f";
export var headerBottomRow = "_es-c";
export var headerTopRow = "_es-b";
export var orderDetailsWrapper = "_es-0";
export var orderInfoContainer = "_es-1";
export var productDetails = "_es-9";
export var productImage = "_es-5";
export var responsiveTable = "_es-8";
export var shipmentContainer = "_es-a";
export var tableBottomLeft = "_es-6";
export var tableBottomRight = "_es-7";
export var trackingLink = "_es-g";